import { Navigate, Outlet } from 'react-router-dom';
import { useCentreAuth } from '@/context/CentreAuthContext';

export function CentreOwnerRoute() {
  const { isCentreAuthenticated, loading } = useCentreAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isCentreAuthenticated) {
    return <Navigate to="/partner/login" replace />;
  }

  return <Outlet />;
}
